import { rem } from '../../../utils/rem';
export var MuiTabs = {
    defaultProps: { textColor: 'secondary' },
    styleOverrides: {
        root: {
            height: rem(36),
            minHeight: rem(36),
        },
        scroller: {
            paddingBlock: 0,
            paddingInline: rem(2),
        },
        flexContainer: {
            columnGap: rem(24),
            flexWrap: 'wrap',
        },
        indicator: {
            display: 'none',
        },
    },
    customOverrides: {
        small: {
            minHeight: rem(34),
            '& [class*=MuiTab-root]': {
                fontSize: '0.775rem',
                minHeight: rem(34),
                '&[class*=Mui-focusVisible]': {
                    minHeight: rem(30),
                },
            },
        },
    },
};
